import sdl from '@jds/react-generated-sdl/JDSBottomNavigation';
import type { JDSBottomNavigationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, BottomNavProps } from '../logic';

const Component = (props: BottomNavProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { multiLine = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { multiLine, ...rest },
    'JDSBottomNavigation',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomNav = withLogic(Component) as React.FC<BottomNavProps> & {
  slotName?: string;
};

BottomNav.displayName = 'BottomNav';
BottomNav.slotName = 'jds_bottom_navigation';

export { BottomNav, type JDSBottomNavigationProps };
